export const SET_USU_DELEGACAO_HIST = 'USU_DELEGACAO_HIST/SET_USU_DELEGACAO_HIST'

export const SET_GERAR_RELATORIO_USU_DELEGACAO = 'USU_DELEGACAO_HIST/SET_GERAR_RELATORIO_USU_DELEGACAO'

export const LOADING_RELATORIOS = 'USU_DELEGACAO_HIST/LOADING_RELATORIOS'
